// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "sequence_execution".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { sequenceExecutionStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "sequence_execution" table (1:1 with a DB row, on the wire). */
export const sequenceExecutionAtomSchema = z.object({
    id: z.string(),
    leadId: z.string(),
    sequenceId: z.string(),
    stepId: z.string(),
    status: z.enum(sequenceExecutionStatusValues),
    result: z.unknown().nullable(),
    scheduledAt: z.string().datetime().nullable(),
    executedAt: z.string().datetime().nullable(),
    errorMessage: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=sequenceExecution.js.map